export function floorWithPrecision(number, precision: number = 100000): number {
    return Math.floor(precision * number) / precision;
}

export function roundWithPrecision(number: number, precision: number = 100000): number {
    return Math.round(precision * number) / precision;
}

export function ceilWithPrecision(number: number, precision: number = 100000): number {
    return Math.ceil(precision * number) / precision;
}

export function adjustToMinMax(number: number, min: number, max: number): number {
    return number > max ? max : number < min ? min : number;
}

export function snap(coord: number, stepLength: number, radius: number) {
    const rest = coord % stepLength;
    const snappedToLeft = coord - rest;

    if (rest <= radius) {
        return snappedToLeft;
    }

    if (rest >= stepLength - radius) {
        return snappedToLeft + stepLength;
    }

    return coord;
}

export function clamp(num: number, min: number | null, max: number | null): number {
    if (min !== null && num <= min) {
        return min;
    } else if (max !== null && num >= max) {
        return max;
    }

    return num;
}



// WEBPACK FOOTER //
// ./src/utils/math.ts